import { useDispatch, useSelector } from "react-redux"
import { hideContactUs } from "../../actions/ui.actions";
import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay } from "@chakra-ui/react";
import TicketCreation from "./TicketCreation";

const ContactUsDrawer = () =>{
    const uiSelector = useSelector(state => state.ui);
    const dispatcher = useDispatch();

    const toggleTalkAgentDrawer = () => {
        dispatcher(hideContactUs());
    }
    return (
        uiSelector.isDrawerOpen && (
            <Drawer isOpen={uiSelector.isDrawerOpen} placement="right" onClose={toggleTalkAgentDrawer}>
            <DrawerOverlay />
            <DrawerContent maxWidth={{ base: "100%", sm: "80%", md: "60%", lg: "40%", xl: "30%" }}>
              <DrawerCloseButton />
              <DrawerBody>
                <TicketCreation title={uiSelector?.ticketTitle} ticket_type={uiSelector?.ticketType} propertyId={uiSelector?.propertyId}/>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        )
    )
};

export default ContactUsDrawer;